export default __webpack_public_path__ + "static/media/nightmare.566b6ed9.jpg";